import { SalesLead } from '~/models/SalesLead'
import { BaseRepository } from '../baseRepository'
import { SalesLeadEntityMapper } from './entityMapper'
import { SalesLeadApiMapper } from './apiMapper'
import { ApiSalesLead } from './apiTypes'
import { Itinerary2 } from '~/models/Itinerary'
import { ItineraryEntityMapper } from '../itinerary/entityMapper'
import { ApiItinerary } from '../itinerary/apiTypes'

export class SalesLeadRepository extends BaseRepository {
	static resource = 'v1/marketplace/sales_leads'

	static async createLead(salesLead: SalesLead): Promise<SalesLead> {
		const apiLead = SalesLeadApiMapper.toSalesLead(salesLead)

		const response: ApiSalesLead | undefined = await this.post(`${this.resource}/`, apiLead)

		return SalesLeadEntityMapper.toSalesLead(response!)
	}

	static async getLeadByTripId(tripId: string): Promise<SalesLead> {
		const params: Record<string, string> = {
			itinerary_id: tripId,
		}

		const response: ApiSalesLead | undefined = await this.get(`${this.resource}/filtered/`, params)

		return SalesLeadEntityMapper.toSalesLead(response!)
	}

	static async createTrip(salesLeadId: string): Promise<Itinerary2> {
		const response: ApiItinerary | undefined = await this.post(
			`${this.resource}/${salesLeadId}/trips/`
		)
		return ItineraryEntityMapper.toItinerary(response!)
	}
}
